import { TruckIcon, BuildingStorefrontIcon } from "@heroicons/react/24/solid";
import { ICart } from "../../../utils/types";

type Props = {
  cart: ICart;
  isFreeDelivery?: boolean;
};

const DeliveryDetailsCard = ({ cart, isFreeDelivery = false }: Props) => {
  const isPickup = cart?.pickup != null;
  const currency = cart?.products?.[0]?.currency ?? "";

  if (!cart?.delivery && !cart?.pickup) return null;

  return (
    <div className="p-2 rounded-sm flex flex-col my-2">
      <div className="bg-gray-50 p-4 rounded-xl">
        <div className="flex items-center gap-2 mb-3">
          {isPickup ? (
            <BuildingStorefrontIcon className="w-5 h-5 text-green-600" />
          ) : (
            <TruckIcon className="w-5 h-5 text-blue-600" />
          )}
          <h3 className="font-semibold text-gray-800">Delivery details</h3>
        </div>

        <div className="text-sm text-gray-700 space-y-2">
          <div className="flex justify-between">
            <span className="font-medium text-gray-600">Type:</span>
            <span className="text-gray-900">
              {isPickup ? "Pickup" : "Delivery"}
            </span>
          </div>

          <div className="flex justify-between items-start">
            <span className="font-medium text-gray-600">Location:</span>
            <span className="text-gray-900 text-right max-w-[60%] break-words">
              {isPickup
                ? cart.pickup?.location ?? "—"
                : cart.delivery?.location ?? "—"}
            </span>
          </div>

          {!isPickup && cart.delivery?.price != null && (
            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-600">Delivery fee:</span>
              <div className="flex items-center gap-2">
                <span
                  className={`text-gray-900 font-medium ${isFreeDelivery ? "line-through text-gray-400" : ""}`}
                >
                  {currency} {Number(cart.delivery.price).toFixed(2)}
                </span>
                {isFreeDelivery && (
                  <span className="text-[10px] bg-green-200 px-1 rounded font-medium text-green-600">
                    Free
                  </span>
                )}
              </div>
            </div>
          )}

          {(isPickup ? cart.pickup?.remarks : cart.delivery?.remarks) && (
            <div className="flex justify-between items-start">
              <span className="font-medium text-gray-600">Remarks:</span>
              <span className="text-gray-500 text-right max-w-[60%] break-words text-xs">
                {isPickup ? cart.pickup?.remarks : (cart.delivery as any)?.remarks}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliveryDetailsCard;
